import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "42",
  height: "42",
  viewBox: "0 0 42 42",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8.63672 7.63672C8.08443 7.63672 7.63672 8.08443 7.63672 8.63672V18.0913C7.63672 18.6435 8.08443 19.0913 8.63672 19.0913H18.0913C18.6435 19.0913 19.0913 18.6436 19.0913 18.0913V8.63672C19.0913 8.08443 18.6436 7.63672 18.0913 7.63672H8.63672ZM23.9094 7.63672C23.3572 7.63672 22.9094 8.08443 22.9094 8.63672V18.0913C22.9094 18.6435 23.3572 19.0913 23.9094 19.0913H33.364C33.9163 19.0913 34.364 18.6436 34.364 18.0913V8.63672C34.364 8.08443 33.9163 7.63672 33.364 7.63672H23.9094ZM22.9094 23.9094C22.9094 23.3572 23.3572 22.9094 23.9094 22.9094H33.364C33.9163 22.9094 34.364 23.3572 34.364 23.9094V33.364C34.364 33.9163 33.9163 34.364 33.364 34.364H23.9094C23.3572 34.364 22.9094 33.9163 22.9094 33.364V23.9094ZM8.63672 22.9094C8.08443 22.9094 7.63672 23.3572 7.63672 23.9094V33.364C7.63672 33.9163 8.08443 34.364 8.63672 34.364H18.0913C18.6435 34.364 19.0913 33.9163 19.0913 33.364V23.9094C19.0913 23.3572 18.6436 22.9094 18.0913 22.9094H8.63672Z",
  fill: "#475F7B"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("mask", {
  id: "mask0_1612_31761",
  style: {"mask-type":"luminance"},
  maskUnits: "userSpaceOnUse",
  x: "7",
  y: "7",
  width: "28",
  height: "28"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M8.63672 7.63672C8.08443 7.63672 7.63672 8.08443 7.63672 8.63672V18.0913C7.63672 18.6435 8.08443 19.0913 8.63672 19.0913H18.0913C18.6435 19.0913 19.0913 18.6436 19.0913 18.0913V8.63672C19.0913 8.08443 18.6436 7.63672 18.0913 7.63672H8.63672ZM23.9094 7.63672C23.3572 7.63672 22.9094 8.08443 22.9094 8.63672V18.0913C22.9094 18.6435 23.3572 19.0913 23.9094 19.0913H33.364C33.9163 19.0913 34.364 18.6436 34.364 18.0913V8.63672C34.364 8.08443 33.9163 7.63672 33.364 7.63672H23.9094ZM22.9094 23.9094C22.9094 23.3572 23.3572 22.9094 23.9094 22.9094H33.364C33.9163 22.9094 34.364 23.3572 34.364 23.9094V33.364C34.364 33.9163 33.9163 34.364 33.364 34.364H23.9094C23.3572 34.364 22.9094 33.9163 22.9094 33.364V23.9094ZM8.63672 22.9094C8.08443 22.9094 7.63672 23.3572 7.63672 23.9094V33.364C7.63672 33.9163 8.08443 34.364 8.63672 34.364H18.0913C18.6435 34.364 19.0913 33.9163 19.0913 33.364V23.9094C19.0913 23.3572 18.6436 22.9094 18.0913 22.9094H8.63672Z",
    fill: "white"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("g", { mask: "url(#mask0_1612_31761)" }, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render };